import { render, staticRenderFns } from "./consultationManage.vue?vue&type=template&id=0c893ce6&scoped=true&"
import script from "./consultationManage.vue?vue&type=script&lang=js&"
export * from "./consultationManage.vue?vue&type=script&lang=js&"
import style0 from "./consultationManage.vue?vue&type=style&index=0&id=0c893ce6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c893ce6",
  null
  
)

export default component.exports